
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";
import { toastError, toastSuccess } from "../../AlertMessage/AlertMessage";

// Get Table Data
export const GeneralInformationTableDataAPI = createAsyncThunk("GeneralInformationTableData", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        T_SurveyorGeneralInfoID,
        M_StateNameID,
        M_RegionalOfficeID,
        M_DistrictNameID,
        SurveyorName,
        FromTop,
        ToTop,
        M_TableUserMasterID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Transaction/Get_Web_T_SurveyorGeneralInfo_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&T_SurveyorGeneralInfoID=${T_SurveyorGeneralInfoID}&M_StateNameID=${M_StateNameID}&M_DistrictNameID=${M_DistrictNameID}&M_RegionalOfficeID=${M_RegionalOfficeID}&SurveyorName=${SurveyorName}&M_TableUserMasterID=${M_TableUserMasterID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data) {
                    return result.data
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const GeneralInformationTableDataSlice = createSlice({
    name: "GeneralInformationTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GeneralInformationTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GeneralInformationTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(GeneralInformationTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const GeneralInformationTableDataReducer = GeneralInformationTableDataSlice.reducer

// InsertUpdate Table Data
export const GeneralInformationPostAPI = createAsyncThunk("GeneralInformationPost", async ({ data }) => {
    const {
        T_SurveyorGeneralInfoID,
        FinancialYearID,
        MonthsID,
        M_StateNameID,
        M_RegionalOfficeID,
        M_FieldStationOfficerID,
        M_DistrictNameID,
        M_TalukaNameID,
        M_VillageNameID,
        M_Village_Wise_ClusterID,
        M_IndicatorMaster_MonitoringID,
        M_AgencyID,
        M_TableUserMasterID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_SurveyorGeneralInfoID", T_SurveyorGeneralInfoID);
    formdata.append("FinancialYearID", FinancialYearID);
    formdata.append("MonthsID", MonthsID);
    formdata.append("M_StateNameID", M_StateNameID);
    formdata.append("M_RegionalOfficeID", M_RegionalOfficeID);
    formdata.append("M_FieldStationOfficerID", M_FieldStationOfficerID);
    formdata.append("M_DistrictNameID", M_DistrictNameID);
    formdata.append("M_TalukaNameID", M_TalukaNameID);
    formdata.append("M_VillageNameID", M_VillageNameID);
    formdata.append("M_Village_Wise_ClusterID", M_Village_Wise_ClusterID);
    formdata.append("M_AgencyID", M_AgencyID);
    formdata.append("M_IndicatorMaster_MonitoringID", M_IndicatorMaster_MonitoringID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "PATCH",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/APK_T_SurveyorGeneralInfo_Update`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleIsPost()
                toastSuccess(result.message)
            } else {
                toastError("Something went wrong")
            }
            return result
        })
})

const GeneralInformationPostSlice = createSlice({
    name: "BeneficiaryPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GeneralInformationPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(GeneralInformationPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(GeneralInformationPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;
            // toastError('Something went wrong')

        });
    },
})

export const GeneralInformationPostReducer = GeneralInformationPostSlice.reducer

export const GeneralInformationDeleteAPI = createAsyncThunk("GeneralInformationDelete", async ({ data }) => {
    const {
        T_SurveyorGeneralInfoID,
        M_TableUserMasterID,
        token,
        handleIsPost,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_SurveyorGeneralInfoID", T_SurveyorGeneralInfoID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/APK_T_SurveyorGeneralInfo_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsPost()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const GeneralInformationDeleteSlice = createSlice({
    name: "GeneralInformationDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GeneralInformationDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(GeneralInformationDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(GeneralInformationDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const GeneralInformationDeleteReducer = GeneralInformationDeleteSlice.reducer